export interface IEventAgent<T extends Record<string, unknown>, K extends keyof T> {
  name: string
  handleEvent: (eventName: K, eventValue?: T[K]) => void
}

export interface IEventRecorder<T extends Record<string, unknown>> {
  agents: IEventAgent<T, keyof T>[]
  addAgent: (agent: IEventAgent<T, keyof T>) => void
  record: (eventName: keyof T, eventValue?: T[keyof T]) => void
}

export type TAgent<T extends Record<string, unknown>, K extends keyof T> = {
  name: string
  handleEvent: (eventName: K, eventValue?: T[K]) => void
}

export default class RecordEvent<T extends Record<keyof T, unknown>> implements IEventRecorder<T> {
  agents: IEventAgent<T, keyof T>[] = []

  addAgent(agent: IEventAgent<T, keyof T>) {
    this.agents.push(agent)
  }

  record(eventName: keyof T, eventValue?: T[keyof T]) {
    this.agents.forEach((agent) => {
      agent.handleEvent(eventName, eventValue)
    })
  }
}
